<div id="login-message" class="grid mb-5">
  <div class="col-12">
    <h1 i18n>Edit Login Message</h1>
    <p i18n>On this page you can enter a Text which will be displayed to every user who tries to login</p>
  </div>

  <p i18n>Enter the Login Message here:</p>
  <div>
    <form>
      @if (messageType === 'CHANGES_SAVED') {
        <p-message severity="info" closable i18n>Updated Login message successfully</p-message>
      }
      <p-inputgroup>
      <textarea
        pTextarea
        id="loginMessage"
        name="loginMessage"
        [(ngModel)]="loginMessage"
        rows="4"
        cols="50"
        maxlength="5000"
        aria-label="login-message-edit"
        [placeholder]="appService.getLoginMessage()">
      </textarea>

      </p-inputgroup>
      <button class="p-button form-btn" (click)="saveMessage()" i18n>Save</button>
    </form>
  </div>
</div>
